import React from 'react';
import { BarLoader } from 'react-spinners';
import { Link } from 'gatsby';
import Box from '../Box';
const types = {
  button: 'button',
  submit: 'submit'
};
const Button = _ref => {
  let {
    children,
    disabled,
    download,
    link,
    renderLoading,
    simple,
    submitting,
    sx,
    type,
    ...rest
  } = _ref;
  const simpleSx = {
    color: 'accent'
  };
  const buttonSx = {
    alignItems: 'center',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    opacity: disabled ? 0.3 : 1,
    pointerEvents: disabled ? 'none' : 'auto',
    textDecoration: 'none',
    whiteSpace: 'nowrap'
  };
  const commonProps = {
    disabled: disabled || submitting,
    sx: {
      ...(simple ? simpleSx : buttonSx),
      ...sx
    },
    variant: simple ? null : 'buttons.primary',
    ...rest
  };
  if (link) {
    return download ? /*#__PURE__*/React.createElement(Box, Object.assign({
      as: Link,
      download: true,
      href: link
    }, commonProps), children) : /*#__PURE__*/React.createElement(Box, Object.assign({
      as: Link,
      disabled: disabled,
      to: link
    }, commonProps), children);
  }
  const innerButton = simple ? children : /*#__PURE__*/React.createElement(Box, {
    alignItems: "center",
    display: "flex",
    height: "1em",
    justifyContent: "center"
  }, submitting ? renderLoading : children);
  return type === types.button ? /*#__PURE__*/React.createElement(Box, Object.assign({
    as: "button",
    type: "button"
  }, commonProps), innerButton) : /*#__PURE__*/React.createElement(Box, Object.assign({
    as: "button",
    type: "submit"
  }, commonProps), innerButton);
};
Button.defaultProps = {
  disabled: false,
  download: false,
  link: null,
  renderLoading: /*#__PURE__*/React.createElement(BarLoader, {
    color: "white"
  }),
  simple: false,
  submitting: false,
  sx: {},
  type: types.button
};
export default Button;